import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(private router: Router) {
    // Guarda la última ruta visitada en localStorage
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        localStorage.setItem('lastRoute', event.urlAfterRedirects);
      }
    });
  }

  restoreLastRoute() {
    const lastRoute = localStorage.getItem('lastRoute');
    // Evita volver al login si no es necesario
    if (lastRoute && lastRoute !== '/login') {
      this.router.navigateByUrl(lastRoute);
    }
  }
}